import { Timesheets } from '../../types/timers'

export const grabDatesFromTimesheets = (data: Timesheets): Date[] => {
  return data.flatMap((timesheet) => new Date(timesheet.date)) //e.g. 31 Oct 2022 00:00:00
}
